import type { Dayjs } from 'dayjs';

export type CreatedRange = [Dayjs | null, Dayjs | null] | null;

export type CreatedRangeParams = { createdFrom?: string; createdTo?: string };

export const createdRangeParams = (range: CreatedRange): CreatedRangeParams => {
  const params: CreatedRangeParams = {};
  if (range?.[0]) params.createdFrom = range[0].startOf('day').toISOString();
  if (range?.[1]) params.createdTo = range[1].endOf('day').toISOString();
  return params;
};

export const hasCreatedRange = (range: CreatedRange): boolean => Boolean(range?.[0] || range?.[1]);
